export default "__VITE_ASSET__BQmrIlFr__"